import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import StyledTextField from '@shared/components/StyledTextField';

const PriceFilter = ({
  fixedPriceMin,
  filteredPriceMin,
  setFilteredPriceMin,
  fixedPriceMax,
  filteredPriceMax,
  setFilteredPriceMax,
  handlePriceInputChange,
}) => {
  return (
    <Grid item lg={12} sm={12} xs={12} sx={{ mt: 2 }}>
      <Typography sx={{ fontSize: '17px', color: 'black', fontWeight: 600 }}>
        Precios
      </Typography>

      <Grid
        container
        spacing={2}
        sx={{ display: 'flex', justifyContent: 'space-around', mt: 1 }}
      >
        <Grid item xs={6}>
          <StyledTextField
            label={`Desde USD ${fixedPriceMin}`}
            placeholder={String(fixedPriceMin)}
            id="min-price"
            variant="outlined"
            autoFocus
            type="number"
            value={filteredPriceMin}
            onChange={event => {
              const value = event.target.value;
              setFilteredPriceMin(value);
              handlePriceInputChange(value, 1);
            }}
            inputProps={{ style: { fontSize: 16, min: 0 } }}
          />
        </Grid>

        <Grid item xs={6}>
          <StyledTextField
            label={`Hasta USD ${fixedPriceMax}`}
            id="max-price"
            variant="outlined"
            autoFocus
            fullWidth
            type="number"
            value={filteredPriceMax}
            onChange={event => {
              const value = event.target.value;
              if (value <= fixedPriceMax) {
                setFilteredPriceMax(value);
                handlePriceInputChange(value, 2);
              }
            }}
            inputProps={{ style: { fontSize: 16, min: 0 } }}
          />
        </Grid>
      </Grid>

      <Divider sx={{ mt: 1 }} />
    </Grid>
  );
};

export default PriceFilter;
